import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { getMoviesByIds } from '@/lib/movieData';

export default function TopicShowcase() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-5 md:mb-6">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider text-accent-600 uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            编辑精选
          </span>
          <h2 className="mt-1.5 font-display text-2xl md:text-3xl font-bold text-foreground-950">当下值得一看的专题</h2>
          <p className="mt-1.5 text-sm text-foreground-500 max-w-2xl">由久久热编辑团队围绕主题策划的内容合集，帮你成体系地发现好作品。</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
        {topics.map((topic, i) => {
          const preview = getMoviesByIds(topic.groups.flatMap((g) => g.movieIds)).slice(0, 4);
          const featured = i === 0;
          return (
            <Link
              key={topic.id}
              to={`/topic/${topic.id}`}
              className={`group relative overflow-hidden rounded-lg cursor-pointer ${featured ? 'lg:col-span-1' : ''}`}
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={topic.cover}
                  alt={`${topic.title} 专题封面`}
                  title={`${topic.title} - 久久热精选专题`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent" />
              </div>

              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <span className="inline-flex items-center h-6 px-2 rounded-md bg-accent-500 text-accent-950 text-xs font-semibold">
                  {topic.groups.length} 组推荐
                </span>
                <h3 className="mt-2.5 font-display text-lg md:text-xl font-bold text-background-50">{topic.title}</h3>
                <p className="mt-1 text-xs md:text-sm text-background-100/85 line-clamp-1">{topic.subtitle}</p>
                <div className="mt-3 flex items-center gap-2">
                  {preview.map((m) => (
                    <span key={m.id} className="w-8 h-11 rounded-md overflow-hidden border border-background-100/30 bg-background-200">
                      <img src={m.poster} alt={`${m.title} 海报`} title={`${m.title} - 久久热`} className="w-full h-full object-cover object-top" />
                    </span>
                  ))}
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-400 ml-1">
                    进入专题
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}